// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProBadge":"bem_a bht_rj bht_rk bht_vh bht_eb bht_vf bht_gu bht_kh"};